import React from 'react';
import Wrapper from 'components/Wrapper';
import Text from 'components/Text';
import { fontSizes } from 'appconstants';
import { ReactSVG } from 'react-svg';
import { back_icon } from 'asset/icons';
import DistributionCenterFunction from './index.function';
import SectionCard from 'components/SectionCard';
import RowView from 'components/RowView';

const DistributionCenter = () => {
  const { navigate } = DistributionCenterFunction();

  const rooms = [1, 2];

  return (
    <Wrapper>
      {/* Header */}
      <div className='flex items-center gap-3 mb-6'>
        <div
          onClick={() => navigate(-1)}
          className='h-10 w-10 cursor-pointer rounded-md flex items-center justify-center bg-muted hover:bg-muted/50 transition'
        >
          <ReactSVG src={back_icon} />
        </div>
        <Text text='Distribution Center - Rooms' size={fontSizes.h24} className='font-bold' />
      </div>

      {rooms.map((room) => (
        <div key={room} className='mb-12'>
          <Text text={`Room ${room}`} size={fontSizes.h26} className='font-bold mb-3' />

          {/* TOP GRID */}
          <div className='grid grid-cols-1 lg:grid-cols-2 gap-6'>
            <div className='flex flex-col gap-6'>
              <SectionCard title='Audit Complete'>
                <Text text='All rooms inspected (6 out of service)' className='text-muted-foreground mb-2' size={fontSizes.h14} />
                <RowView label='Room Manufacturer' value='Thermal Technologies' />
                <RowView label='Capacity' value='18 – 3-tier with 42-pallet capacity each' />
                <RowView label='Room Age' value='25 (Rooms 1–11), 14 (Rooms 8–12), 18 (Rooms 12–18)' />
                <RowView label='Ethylene Type' value='Easy-Ripe Catalytic Generator' />
                <RowView label='Door Type' value='Rollseal (Rooms 1–18) & BG Doors (Rooms 12–18)' />
                <RowView label='Humidifier Type' value='Stulz Humidifiers' className='border-b-0' />
              </SectionCard>
              <SectionCard title='Air Flow and Room Loading' className='flex-1'>
                <Text
                  text='All loaded rooms had static air pressure above the recommended minimum of 0.25 inches of water.'
                  className='text-muted-foreground'
                  size={fontSizes.h14}
                />
                <Text
                  text={
                    <>
                      <Text text={'Range:'} className='inline font-semibold' size={fontSizes.h14} /> 0.26 – 0.44 inches of water. Room 14 was loaded
                      improperly (shifted pallet).
                    </>
                  }
                  className='text-muted-foreground my-2'
                  size={fontSizes.h14}
                />
                <Text text='Temperature Control' className='font-bold mt-5' size={fontSizes.h18} />
                <Text
                  text='Pulp temperatures were within ±2°F of control sensor readings except rooms 1, 2, 4, 5, 7, 9, 10, 12, 14, 16 and 18.'
                  className='text-muted-foreground'
                  size={fontSizes.h14}
                />
              </SectionCard>
            </div>

            {/* Structural Observations */}
            <SectionCard title='Structural Observations'>
              <Text text='Room Leaks (Ethylene, Humidity, Cooling/Heating Efficiency)' className='text-muted-foreground mb-3' size={fontSizes.h14} />
              <RowView label='Door Leak' value='Rooms 16, 17, 18' />
              <RowView label='Cracked Caulking' value='Rooms 16 and 18' />
              <RowView label='Door Seals (wavy and pinched)' value='Rooms 16 and 17' />
              <RowView label='Missing Velcro' value='Room 5' className='border-b-0' />
              <Text text='Airflow:' className='text-muted-foreground my-3' size={fontSizes.h14} />
              <RowView label='Improperly Installed Gaskets' value='Rooms 16, 17, 18' />
              <RowView label='Improperly Installed Curtains' value='Rooms 16 and 18' />
              <RowView label='Gaps Between Sheet Metal & Racking' value='Rooms 16 and 17' />
              <RowView label='Gasket Memory' value='Room 5' className='border-b-0' />
              <Text text='General Room Maintenance:' className='text-muted-foreground my-3' size={fontSizes.h14} />
              <RowView label='Damage on Outer Door' value='Rooms 16 and 18' />
              <RowView label='Torn Curtains' value='Rooms 16 and 18' />
              <RowView label='Detached Gasket Strap' value='Rooms 16 and 17' className='border-b-0' />
            </SectionCard>
          </div>

          {/* Ripening Process */}
          <SectionCard title='Ripening Process' className='mt-6'>
            <div className='grid grid-cols-1 lg:grid-cols-2 gap-6'>
              <div className='col-span-1'>
                <RowView
                  label='Room Checks'
                  value='Samples are pulled and only color is used out of the indicators adjustments are made and notes are taken on ripening log'
                  className='flex-col gap-3'
                  detailTextClassName='text-left'
                />
                <RowView label='Gassing Temperature' value='59.0 – 61.0°F' />
                <RowView label='2 Color Program' value='CV/OG: 2.5 – 3.5' />
                <RowView label='Temperature Adjustments' value='Within ±2°F at a time' />
                <RowView label='Gassing Protocol' value='24 hours' />
                <RowView label='Venting' value='Unknown' />
                <RowView label='Cycle Duration' value='5 days' />
                <RowView label='Staging & Selection Process' value='-' />
                <RowView label='Staging' value='-' className='border-b-0' />
              </div>
              <div className='col-span-1'>
                <RowView
                  label='Ripening Logs'
                  value='Maintained with detailed entries for room numbers, receiving dates, number of cases, date and time of room checks, set points, temperatures, adjustments, gassing/shipment date and remarks.'
                  className='flex-col gap-3'
                  detailTextClassName='text-left'
                />
                <RowView label='Start Time' value='12:00 PM' />
                <RowView label='Pallet Type' value='Partially sealed Pallets- no slip sheets are used' />
                <RowView
                  label='Order Protection'
                  value='Banana bags are used on all orders. Shrink wrap was inconsistently wrapped to the bottom of the pallet.'
                  className='flex-col  gap-3'
                  detailTextClassName='text-left'
                />
                <RowView
                  label='Product Handling'
                  value='Selectors were seen handling the cases in a moderate to rough manner.'
                  className='flex-col  gap-3'
                  detailTextClassName='text-left'
                />
                <RowView
                  label='Dock Ambient Temperature/Time:'
                  value='Orders are left on the dock for up to an hour/ 46.2'
                  className='flex-col gap-3 border-b-0'
                  detailTextClassName='text-left'
                />
              </div>
            </div>
          </SectionCard>

          {/* BOTTOM GRID */}
          <div className='grid grid-cols-1 lg:grid-cols-2 gap-6 mt-6'>
            {/* Humidification */}
            <SectionCard title='Humidification and Ventilation'>
              <RowView label='Humidifier Function' value='All rooms functional except 13, 15, 17, 18, 19' />
              <RowView label='Humidity Reading Range' value='78.1% – 87.8%' />
              <RowView label='Rooms Below Recommended Minimum' value='All loaded rooms' />
              <RowView label='Vent Function' value='Unobservable' className='border-b-0' />
            </SectionCard>

            {/* Sanitation */}
            <SectionCard title='Sanitation Observations'>
              <RowView label='Pulp Piece Cord Mold' value='Rooms 1, 2, 4, 7, 8, 9, 10, 11, 14, 15, 16, 17, 18' />
              <RowView label='Mold on Ceiling' value='Room 10' />
              <RowView label='Mold on Caulking' value='Rooms 12 and 15' />
              <RowView label='Mold on Curtains' value='Rooms 12 and 15' />
              <RowView label='Dirt on Doors' value='Rooms 12 and 15' />
              <RowView label='Debris on Coils' value='Rooms 12 and 15' className='border-b-0' />
            </SectionCard>
          </div>
        </div>
      ))}
    </Wrapper>
  );
};

export default DistributionCenter;
